module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filterProducts":"Filter Products","clear":"Clear","filter":"Filter"},"de":{"filterProducts":"Artikel filtern","clear":"Alle löschen","filter":"????"}}')
  delete Component.options._Ctor
}
